import styled from 'styled-components';
import Slider from 'react-slick';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 960px;
  width: 100%;
`;

export const component = styled.div`
  margin-top: 0.5vh;
  overflow: visible;
`;

export const CustomSlider = styled(Slider)`
  .slick-center {
    transform: scale(1.2);
    transition: transform 0.5s;
  }

  .slick-slide {
    transition: transform 0.5s;
    overflow: visible;
  }

  .slick-list {
    overflow: visible;
  }

  .slick-dots {
    bottom: -15px !important;
    position: relative !important;
  }

  .slick-dots li button:before {
    content: '' !important;
    display: block !important;
    font-size: 0 !important;
    line-height: 0 !important;
    width: 5px !important;
    height: 5px !important;
    background-color: #ccc !important;
    border-radius: 50% !important;
    opacity: 1 !important;
  }

  .slick-dots li {
    width: 5px !important;
    height: 5px !important;
    margin: 0 2px !important;
  }

  .slick-dots li button {
    width: 5px !important;
    height: 5px !important;
    padding: 0 !important;
  }

  .slick-dots li.slick-active button:before {
    background-color: green !important;
  }
`;

export const img = styled.div`
  margin: 0 auto;
  display: inline-block;
`;

export const GreenText = styled.span`
  color: green;
`;

export const Text = styled.div`
  margin-top: 1vh;
  margin-left: 5%;
  font-weight: bold;
  text-align: left;
  font-size: 18px;
`;

export const Tag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const button = styled.div`
  display: inline-block;
  font-size: 12px;
  margin-top: 2vh;
  border-radius: 20px;
  text-align: center;
  border: 1px solid #e0e0e0;
`;

export const container = styled.div`
  margin-top: 3vh;
  padding-bottom: 20px;
`;

export const ImgWrapper = styled.div`
  padding-top: 15px;
  padding-bottom: 20px;
  text-align: center;

  & img {
    width: 170px;
    height: 170px;
    margin: 0 auto 10px auto;
    object-fit: contain;
    background-color: #f0f0f0;
    border-radius: 10px;
  }
`;

export const FacilityName = styled.div`
  text-align: center;
  font-size: 14px;
`;
